import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { GlobalUtilsService } from 'src/app/global-utils.service';

@Component({
  selector: 'app-input-textarea',
  template: `
    <div
      class="input-container"
      (click)="onFocus($event)"
      [ngClass]="{
        disabled: isDisabled,
        isFocused: isFocused,
        tablet: globalUtilsService.isTablet(),
        mobile: globalUtilsService.isMobile()
      }"
    >
      <span
        class="label"
        [ngClass]="{
          'on-top': isFocused || control.value,
          invalid: control.invalid && control.touched && !isFocused
        }"
        >{{ isFocused || control.value ? label : placeholder }}</span
      >
      <div class="input-control-container">
        <textarea
          #input
          class="input-control"
          [ngClass]="{ isFocused: isFocused, hide: !isFocused }"
          [formControl]="control"
          (focus)="onFocus($event)"
          (blur)="blur($event)"
        ></textarea>
        <p
          class="input-control-deactivate"
          *ngIf="!isFocused"
          [ngClass]="{ invalid: control.invalid && control.touched }"
        >
          {{ control.value }}
        </p>
      </div>
    </div>
  `,
  styleUrls: [`../input-control.scss`],
  styles: [
    `
      .input-control-container {
        transition: height 0.35s cubic-bezier(0.075, 0.82, 0.165, 1);
      }

      .input-container.isFocused .input-control-container {
        height: 2.6rem;
        transition: height 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
      }

      .input-container .input-control-container .input-control {
        height: 100%;
        resize: none;
      }

      .input-container.tablet.isFocused .input-control-container {
        height: 3rem;
      }

      .input-container.mobile.isFocused .input-control-container {
        height: 3rem;
      }
      /* .input-control-container {
        height: 100% !important;
      } */
    `
  ]
})
export class InputTextareaComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  placeholder: string;

  @Input()
  control: FormControl;

  @Input()
  mask: string;

  // tslint:disable-next-line: no-output-native
  @Output()
  focusBlur: EventEmitter<boolean>;

  isFocused: boolean;

  @ViewChild('input')
  inputElement: ElementRef;

  isDisabled: boolean;

  constructor(
    private ngZone: NgZone,
    public globalUtilsService: GlobalUtilsService
  ) {
    this.isFocused = false;
    this.focusBlur = new EventEmitter();
  }

  ngOnInit() {
    this.isDisabled = this.control.disabled;
    this.control.registerOnDisabledChange(isDisabled => {
      this.isDisabled = isDisabled;
    });
  }

  onFocus(e) {
    if (this.isDisabled) {
      return;
    }
    this.focusBlur.emit(true);
    this.isFocused = true;
    this.ngZone.onMicrotaskEmpty.pipe(first()).subscribe(() => {
      if (e instanceof MouseEvent) {
        (this.inputElement.nativeElement as HTMLFormElement).focus();
      }
    });
  }

  blur(e) {
    this.focusBlur.emit(false);
    this.isFocused = false;
  }
}
